<template>
  <div class="index">
    <div class="mask loading" @touchmove.prevent.stop @mousewheel.prevent v-if="bShowLoading">
      <img src="../assets/loading.png">
      <span>努力加载中...</span>
    </div>
    <div class="w1200 top">
      <a class="logo-con" :href="OFFICIAL_URL" target="_blank">
        <img src="https://oss.lingjiang.com/images/official/commonly/logo-new-v0314.png" class="logo" />
        <img src="https://oss.lingjiang.com/images/official/commonly/logo-text-v0314.png" class="logo-text">
      </a>
      <div class="topfont">
        <div class="top-nav">
          <a
            class="nav-item"
            v-for="nav in navList"
            :key="nav.name"
            :href="nav.linkUrl"
            target="_blank"
            >{{ nav.name }}</a
          >
        </div>
        <span v-if="!pageToken" class="login-btn" @click="fnShowLogin"
          >登录/注册</span
        >
        <UserDropdown :user="objUserInfo" @logout="fnLogout" v-else />
      </div>
    </div>
    <div class="changeProject" @click="fnProjectTabs()">
      <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/changeProject.png" class="changeProject-img">
      <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/cursor.gif" class="cursor-img">
    </div>
    <div class="banner" :style="{backgroundImage: 'url(' + strBannerUrl +')'}">
      <div class="bannerCon">
        <div class="banner-text">
          <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/laba.png">
          登录后随时查看答案
        </div>
        <div class="banner-ewm">
          <img :src="strEwmImg">
          <div class="banner-ewm-text">
            关注公众号<br>了解更多{{strEwmText}}信息
          </div>
        </div>
      </div>
    </div>

    <div class="timelinebgWrap" v-if="arrPeriods && arrPeriods.length > 0">
      <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/calendar.png" class="calendar-img">
      <div class="timelinebg" ref="timelinebg">
        <!-- 最多展示4期 -->
        <div class="timeline2 borderRadius" v-for="(item, index) in arrPeriods" :class="Date.parse(item.endDate.replace(/-/g, '/')) < nowDateNum ? '' : 'timeline1'"  @click="fnSelectStage(item, index)">
          <div class="status-end status" v-if="Date.parse(item.endDate.replace(/-/g, '/')) < nowDateNum">已结束</div>
          <div class="status-pending status" v-else>进行中</div>
          <span class="name">{{item.name}}</span>
          <div class="linebg" :style="{borderRadius: arrPeriods.length === 1 ? '7px' : index + 1 === arrPeriods.length ? '0 7px 7px 0' : ''}" >
            <div class="cir" :class="activeStageIndex === index ? 'cir-active' : ''"></div>
          </div>
          <span class="time" :class="activeStageIndex === index ? 'time-active' : ''">{{ item.periodDate }}</span>
        </div>
        <!-- 最多四期，如果超过四期不展示 更新中-->
        <div class="timeline2 timeline3">
          <div class="status-nostart status">更新中</div>
          <span class="name">{{arrPeriods.length == 0 ? '一期' : arrPeriods.length == 1 ? '二期' : arrPeriods.length == 2 ? '三期' : arrPeriods.length == 3 ? '四期' : arrPeriods.length == 4 ? '五期': arrPeriods.length == 5 ? '六期': arrPeriods.length == 6 ? '七期' : '八期'}}</span>
          <div class="linebg">
            <div class="cir"></div>
          </div>
          <span class="time">更新中</span>
        </div>
      </div>
    </div>

    <div class="maintitle" v-if="arrPeriods && arrPeriods.length > 0">
      <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/left.png" />考试场次<img
        src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/right.png" />
    </div>
    <div class="ksap" :style="{background: strFontColor}" v-if="arrScencsList && arrScencsList.length > 0">
      <div class="subjects">
        <ul>
          <li v-for="(subject, subjectIndex) in arrScencsList" :key="subjectIndex" :class="subjectIndex === activeSubjectIndex ? 'active' : ''" @click="fnSelectSubject(subject, subjectIndex)" :style="{color: subjectIndex === activeSubjectIndex ? strFontColor : ''}">{{subject.subjectName}}</li>
        </ul>
      </div>
      <div class="scenInfo" v-for="(item, index) in arrScencsList" v-if="activeSubjectIndex === index">
        <!-- <div class="ksaptop">
          <div class="ksaptip">
            请在开考前检查自己电脑的配置是否符合考试要求。
          </div>
          <div class="ksaptip2" @click="checkPc">请点击此处检查电脑配置</div>
        </div> -->
        <div>
          <div class="ksapbg">
            <div class="mktitle">
              <span class="mktitlefont">{{ item.examName }}</span>
            </div>
            <div class="mkicon">
              <ul>
                <li v-for="tag in item.tags">{{ tag }}</li>
              </ul>
            </div>
            <div class="mkdesc">
              <span><img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/day-icon.png">考试时长：{{item.length}}分钟</span>
              <span><img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/day-icon.png">考试日期：{{item.examDate}}<br /></span>
            </div>
            <img
              :src="
                Date.parse(item.endDate.replace(/-/g, '/')) <
                nowDateNum
                  ? bmend
                  : bAppointment
                  ? bmok
                  : ''
              "
              class="mkstatus"
            />
            <a
              href="javascript:void(0)"
              @click="fnAppointment(item)"
              class="enterbtn transition4"
              v-if="!bAppointment && nowDateNum < Date.parse(item.endDate.replace(/-/g, '/'))"
              >立即预约</a
            >
            <a
              href="javascript:void(0)"
              v-if="bAppointment && nowDateNum < Date.parse(item.endDate.replace(/-/g, '/'))"
              @click="enterExam(item, index)"
              class="enterbtn transition4"
              >进入考场</a
            >
            <a
              href="javascript:void(0)"
              class="lookbtn transition4"
              @click="checkAnswer(item)"
              >查看答案</a
            >
          </div>
        </div>
      </div>

    </div>

    <div class="exam-remark">
      <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/exam-remak.png" class="remark-img1">
      <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/exam-remak.png" class="remark-img2">
      <div class="exam-remark-title">考试说明</div>
      <div class="remark-item">1.登录后随时查看答案。</div>
      <div class="remark-item">2.推荐您使用 <span @click="fnDownloadChrome">最新版谷歌浏览器（点击下载）</span>或将360浏览器切换至极速模式。</div>
    </div>
    <div class="maintitle" style="margin-top: 60px" v-if="arrLiveData && arrLiveData.length > 0">
        <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/left.png" />直播场次<img
        src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/right.png" />
      </div>
    <div class="livebg w1200" v-if="arrLiveData && arrLiveData.length > 0">
      <div class="w1200 live">
        <div class="liveplay">
          <div class="liveimg" v-show="bShowLiveimg">
            <img :src="selectLive.imgUrl"/>
            <div class="liveImgBg"></div>
            <div class="liveStatus">{{selectLive.liveStatus === 1 ? '直播未开始' : selectLive.liveStatus === 2 ? '直播进行中' : '直播已结束'}}</div>
            <div class="liveBtn" v-if="selectLive.liveStatus != 1" @click="fnLiveClick()">立即观看</div>
          </div>
          <div class="livemain">
              <div class="lineTitle">直播列表</div>
              <ul>
                <li v-for="(live, liveIndex) in arrLiveData" @click="fnSelectLive(live, liveIndex)">
                  <span class="time" :style="{color: liveIndex === activeLiveIndex ? strFontColor : '', fontWeight: liveIndex === activeLiveIndex ? 700 : ''}">{{live.liveTime}}</span>
                  <span class="title" :style="{color: liveIndex === activeLiveIndex ? strFontColor : '', fontWeight: liveIndex === activeLiveIndex ? 700 : ''}">{{live.title}}</span>
                  <span class="teacher">{{'讲师：' +  live.teachers.join("、")}}</span>
                  <!-- <img src="../assets/time1.png" v-if="liveIndex === activeLiveIndex"/> -->
                  <img src="../assets/time2.png"/>
                </li>
              </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="maintitle" style="margin-top: 70px" v-if="kclist.courses || kclist.thesises || kclist.reviews || kclist.packages">
      <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/left.png" />课程介绍<img
        src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/right.png" />
    </div>
    <div class="w1200" v-if="kclist.courses || kclist.thesises || kclist.reviews || kclist.packages">
      <div class="tabs">
        <span
          class="item"
          v-for="(item, index) in kcTabs"
          :key="index"
          :class="{ active: kcindex == index }"
          @click="tabclick(index)"
          >{{ item }}</span
        >
      </div>
      <div
        class="bluebg"
        v-if="kcindex == 0 && kclist.courses"
      >
        <div class="kcSubject">
          <p v-for="(val, index2) in kclist.courses" :class="kcSubjectIndex===index2 ? 'active' : ''" :key="index2" @click="kcSubjectClick(index2)"> {{ val.subject }}</p>
        </div>
        <div style="display: flex;flex-wrap: wrap;" v-for="(val, courseIndex) in kclist.courses" v-if="kcSubjectIndex == courseIndex">
          <div class="kcmain" v-for="(product, productIndex) in val.products" :key="productIndex">
            <div class="kcname">{{ product.name }}</div>
            <div class="kcbuy">
              <div class="price">
                ￥<strong>{{ product.price }}</strong>
              </div>
              <a :href="product.link.pc" target="_blank" class="buybtn">了解课程详情</a>
            </div>
            <div class="kcright">
              <div class="kcdiv1">
                <div class="kctitle">经典课程</div>
                <ul v-if="product.lessonDesc">
                  <li v-for="desc in product.lessonDesc.split('、') || []">{{ desc }}</li>
                </ul>
              </div>
              <div class="kcdiv2">
                <div class="kctitle">特色服务</div>
                <ul v-if="product.service">
                  <li v-for="desc in product.service.split('、') || []">{{ desc }}</li>
                </ul>
              </div>
              <div class="kcdiv3">
                <div class="kctitle">学习资料</div>
                <ul v-if="product.material">
                  <li v-for="desc in product.material.split('、') || []">{{ desc }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bluebg"
        v-if="kcindex == 1 && kclist.thesises"
      >
        <div style="display: flex;flex-wrap: wrap;">
          <div class="kcmain" v-for="(val, index2) in kclist.thesises" :key="index2">
            <div class="kcname">{{ val.name }}</div>
            <div class="kcbuy">
              <div class="price">
                ￥<strong>{{ val.price }}</strong>
              </div>
              <a :href="val.link.pc" target="_blank" class="buybtn">了解课程详情</a>
            </div>
            <div class="kcright">
              <div class="kcdiv1">
                <div class="kctitle">经典课程</div>
                <ul v-if="val.lessonDesc">
                  <li v-for="desc in val.lessonDesc.split('、') || []">{{ desc }}</li>
                </ul>
              </div>
              <div class="kcdiv2">
                <div class="kctitle">特色服务</div>
                <ul v-if="val.service">
                  <li v-for="desc in val.service.split('、') || []">{{ desc }}</li>
                </ul>
              </div>
              <div class="kcdiv3">
                <div class="kctitle">学习资料</div>
                <ul v-if="val.material">
                  <li v-for="desc in val.material.split('、') || []">{{ desc }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bluebg"
        v-if="kcindex == 2 && kclist.reviews"
      >
        <div style="display: flex;flex-wrap: wrap;">
          <div class="kcmain" v-for="(val, index2) in kclist.reviews" :key="index2">
            <div class="kcname">{{ val.name }}</div>
            <div class="kcbuy">
              <div class="price">
                ￥<strong>{{ val.price }}</strong>
              </div>
              <a :href="val.link.pc" target="_blank" class="buybtn">了解课程详情</a>
            </div>
            <div class="kcright">
              <div class="kcdiv1">
                <div class="kctitle">经典课程</div>
                <ul v-if="val.lessonDesc">
                  <li v-for="desc in val.lessonDesc.split('、') || []">{{ desc }}</li>
                </ul>
              </div>
              <div class="kcdiv2">
                <div class="kctitle">特色服务</div>
                <ul v-if="val.service">
                  <li v-for="desc in val.service.split('、') || []">{{ desc }}</li>
                </ul>
              </div>
              <div class="kcdiv3">
                <div class="kctitle">学习资料</div>
                <ul v-if="val.material">
                  <li v-for="desc in val.material.split('、') || []">{{ desc }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bluebg"
        v-if="kcindex == 3 && kclist.packages"
      >
      <div class="kcSubject">
          <p v-for="(val, index2) in kclist.packages" :class="kcSubjectIndex===index2 ? 'active' : ''" :key="index2" @click="kcSubjectClick(index2)"> {{ val.subject }}</p>
        </div>
        <div style="display: flex;flex-wrap: wrap;" v-for="(val, courseIndex) in kclist.packages" v-if="kcSubjectIndex == courseIndex">
          <div class="kcmain" v-for="(product, productIndex) in val.products" :key="productIndex">
            <div class="kcname">{{ product.name }}</div>
            <div class="kcbuy">
              <div class="price">
                ￥<strong>{{ product.price }}</strong>
              </div>
              <a :href="product.link.pc" target="_blank" class="buybtn">了解课程详情</a>
            </div>
            <div class="kcright">
              <div class="kcdiv1">
                <div class="kctitle">经典课程</div>
                <ul v-if="product.lessonDesc">
                  <li v-for="desc in product.lessonDesc.split('、') || []">{{ desc }}</li>
                </ul>
              </div>
              <div class="kcdiv2">
                <div class="kctitle">特色服务</div>
                <ul v-if="product.service">
                  <li v-for="desc in product.service.split('、') || []">{{ desc }}</li>
                </ul>
              </div>
              <div class="kcdiv3">
                <div class="kctitle">学习资料</div>
                <ul v-if="product.material">
                  <li v-for="desc in product.material.split('、') || []">{{ desc }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />

    <div
      v-if="isShowWebkit"
      class="mask"
      @touchmove.prevent.stop
      @mousewheel.prevent
    >
      <div class="modalcen">
        <div class="modalicon"><img src="../assets/lingdang.png" /></div>
        <div class="modaltitle">温馨提示</div>
        <div class="modalfont">
          您当前使用的浏览器模式暂不能很好的支持题库答题，若您使用360/QQ浏览器，请切换为极速模式，请下载
          Chrome浏览器。<a href="https://pc.qq.com/detail/1/detail_2661.html" target="_blank"
            >点击此处下载谷歌 Chrome 浏览器</a
          >
        </div>
      </div>
    </div>

    <div
      v-if="isWeChat"
      class="mask"
      @touchmove.prevent.stop
      @mousewheel.prevent
    >
      <div class="modalcen">
        <div class="modalicon"><img src="../assets/lingdang.png" /></div>
        <div class="modaltitle">温馨提示</div>
        <div class="wxTips">
          <p>微信中不支持答题</p>
          <p>请复制下面链接，粘贴在浏览器（谷歌、360极速版）中，再进行答题。</p>
          <p class="linkInfo"><span id="text">https://www.lingjiang.com/</span><span @click="copyText">复制链接</span></p>
        </div>
         <div class="modalbtngroup" @click="isWeChat = false">我知道了</div>
      </div>
      <textarea id="input" style="opacity: 0 !important">这是幕后黑手</textarea>
    </div>

    <div
      v-if="showPcTip"
      class="mask"
      @touchmove.prevent.stop
      @mousewheel.prevent
    >
      <div class="modalcen">
        <div class="modalicon"><img src="../assets/lingdang.png" /></div>
        <div class="modaltitle">温馨提示</div>
        <div class="modalfont fexdiv" v-if="isWebkit">
          <img src="../assets/duihao.png" />您当前的浏览器支持本次考试
        </div>
        <div class="modalfont fexdiv" v-if="isWebkit == false">
          <img src="../assets/tanhao.png" />您当前的浏览器不支持本次考试
        </div>
        <div class="modalfont fexdiv" v-if="screenArry[0] < 1920">
          <img src="../assets/tanhao.png" />
          <div>
            您当前电脑显示器分辨率过低({{ screenArry[0] }}*{{
              screenArry[1]
            }}),会影响做题体验。<span class="modaltip"
              >建议您在考试时选择合适的电脑或调整显示的分辨率（要求不低于1920×1080）</span
            >
          </div>
        </div>
        <div class="modalfont fexdiv" v-else>
          <img src="../assets/duihao.png" />您当前电脑显示器分辨率支持本次考试
        </div>
        <div class="modalbtngroup" @click="showPcTip = false">我知道了</div>
      </div>
    </div>



    <!-- 进入考场弹窗 -->
    <div
      v-if="bShowExamTip"
      class="mask"
      @touchmove.prevent.stop
      @mousewheel.prevent
    >
      <div class="modalcen">
        <div class="modalicon"><img src="../assets/lingdang.png" /></div>
        <div class="modaltitle">温馨提示</div>
        <div class="modalfont">
          <p>此次考试时间为<span style="color: red">{{selectScencsItem.length}}分钟</span>，且只有<span style="color: red">1次答题机会</span>，</p>
          <p>请确保自己是否能完成考试。</p>
        </div>
        <div class="btnWrap">
          <div class="modalbtngroup" @click="fnGoExam">现在作答</div>
          <div class="modalbtngroup" @click="bShowExamTip = false">另选时间作答</div>
        </div>
      </div>
    </div>

    <slideNav></slideNav>
    <!-- 选择项目弹窗  -->
    <div
      v-if="bShowProject"
      class="mask"
      @touchmove.prevent.stop
      @mousewheel.prevent
    >
      <div class="modalcen" style="width: 670px">
        <img src="https://oss.lingjiang.com/webstatic/questionbank/images/mock-exam/common/close.png" class="close-img" @click="fnCloseProjectDialog">
        <div class="modaltitle" style="color: red">请选择您要进入的考试专场</div>
        <div class="modalfont" style="margin-top: 0">
          <div class="project-wrap">
            <div class="nav-item" v-for="nav in arrProjectList" :key="nav.navId">
              <img :src="nav.icon">
              <span>{{ nav.navName }}</span>
              <ul class="session-projects">
                <li v-for="(item, index) in nav.children" :class="activeProjectIndex === item.ProjectId ? 'active' : ''" :key="item.ProjectId" class="project-item" @click="fnSelectProject(item)">{{ item.NickName }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 登录弹窗 -->
    <LoginDialog ref="loginDialog" @success="onLoginSuccess" @cancel="onLoginCancel"
    />
  </div>
</template>

<script>
import * as api from '../api/api.js';
import slideNav from '../components/sidenav.vue'
import Footer from '@/components/footer.vue';
import UserDropdown from "@/components/user-dropdown.vue";
import LoginDialog from "@/utils/loginDialog.esm.js";
const OFFICIAL_URL = api.OFFICIAL_URL;
const exam_url_kj = api.EXAM_URL_ACC; // 会计类作答页面域名
const exam_url_jj = api.EXAM_URL_ECO; // 经济类作答页面域名
export default {
  components: {
    slideNav,
    Footer,
    UserDropdown,
    LoginDialog
  },
  data() {
    return {
      OFFICIAL_URL,
      ChannelSource: 0,
      bShowLoading: false,
      bShowProject: false,
      strSceneId: '',
      bAppointment: false,
      bmend: require('../assets/bmend.png'),
      bmok: require('../assets/bmok.png'),
      RegNID: '', //方案id
      pageToken: "",
      objUserInfo: null,
      userid: '',
      tiKuUserId: '',
      // 顶部导航链接
      navList: [
        { name: "选课中心", linkUrl: `${OFFICIAL_URL}/products` },
        { name: "试听课", linkUrl: `${OFFICIAL_URL}/listens` },
        {
          name: "评审专题",
          linkUrl:
            `${OFFICIAL_URL}/spread/review/2023/topic/index.html#/`,
        },
        {
          name: "模考",
          linkUrl: window.location.href,
        },
      ],

      arrPeriods: [], // 期数据
      currentPeriod: {}, // 当前期
      arrScencsList: [], //场次数据

      modaldiv: false,

      isShowWebkit: false,
      isWebkit: true,
      showPcTip: false,
      screenArry: [],
      kcindex: 0,
      kcSubjectIndex: 0,
      kcTabs: ['课程','论文辅导班','评审指导班','全程套餐班',],
      kclist: {},
      nowDateNum: Date.parse(new Date($.ajax({async: false}).getResponseHeader("Date"))),
      isWeChat: false,
      bShowExamTip: false,
      selectScencsItem: {},
      arrProjectList: [
        { navId: 321, navName: '财会培训', icon: 'https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/project_ck.jpg', children: []},
        { navId: 324, navName: '经济师培训', icon: 'https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/project_jjs.jpg', children: []}
      ],
      activeProjectIndex: -1,
      activeStageIndex: 0,
      strBannerUrl: 'https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/banner/01-banner.jpg', // bannner链接
      strFontColor: 'rgba(10, 103, 234, 1)', // 字体颜色
      activeSubjectIndex: 0,

      bShowLiveimg: true,
      arrLiveData: [],
      activeLiveIndex: 0,
      selectLive: {},

      IsContinue: '',
      examId: '',

      bNumbtnDisabled: false,
      strEwmImg: '',
      strEwmText: ''
    };
  },
  created() {
    // 废弃初级会计师, 默认选中高会
    try {
      const selectedProjectStr = localStorage.getItem('selectProject');
      const selectedProject = selectedProjectStr ? JSON.parse(selectedProjectStr) : null;

      // 检查 selectedProject 是否存在以及 ProjectId 属性是否为 7
      if (selectedProject && selectedProject.ProjectId === 7) {
          localStorage.removeItem('selectProject');
      }
    } catch (error) {
      console.error("Error", error);
    }
    // 使用官网登陆状态
    this.pageToken = Cookies.get("token") || "";
    this.ChannelSource = this.getQueryString('ChannelSource') || 0;
    if(!this.checkOs().isPc){
       window.location.href = `./m/index.html?ChannelSource=${this.ChannelSource}`; //跳转到H5版
    }
    // 获取用户信息
    this.getUserDetail(this.pageToken);
    // 获取项目数据
    this.fnGetProjectList()
  },
  mounted() {
    this.judgeBrowserType();
    this.fnGetScreenSize();
    this.fnIsShowLoginDialog();
  },
  methods: {
    getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
    },
    // 下载浏览器
    fnDownloadChrome() {
      window.open('https://pc.qq.com/detail/1/detail_2661.html', '_blank')
    },
    initData() {
      this.bShowLoading = true
      setTimeout(() => {
        this.bShowLoading = false;
      }, 1200);
      this.activeStageIndex = 0
      this.activeSubjectIndex = 0
      this.activeLiveIndex = 0
      this.kcindex = 0
      this.kcSubjectIndex = 0
      let project_id = JSON.parse(localStorage.getItem('selectProject')).ProjectId
      if(project_id == 1 || project_id == 38) { // 只有高会和高经有 '论文辅导班' '评审指导班' '全程套餐班'
        this.kcTabs = ['课程','论文辅导班','评审指导班','全程套餐班']
      } else {
        this.kcTabs = ['课程']
      }
      // 设置二维码
      if(project_id == 1 || project_id == 6 || project_id == 7 ||  project_id ==15) {
        this.strEwmImg = 'https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/gkewm.jpg'
        this.strEwmText = '会计'
      } else {
        this.strEwmImg = 'https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/gjewm.jpg'
        this.strEwmText = '经济'
      }
      api
        .getPageData(project_id)
        .then((res) => {
          if(res.data) {
            let pageData = res.data;
            this.strBannerUrl = pageData.bannerUrl;
            this.strFontColor = pageData.fontColor;
            this.RegNID = pageData.planId; // 当前项目对应的方案ID
            this.arrPeriods = pageData.periods || []; // 期数据
            this.activeStageIndex = this.arrPeriods.length - 1; // 时间线选中下标 最后一个
            this.currentPeriod = this.arrPeriods[this.arrPeriods.length - 1]; // 当前期
            this.arrScencsList = this.currentPeriod.exams; // 场次数据
            this.strSceneId = this.currentPeriod.exams[0].sceneId; // SceneId
            this.$nextTick(()=>{
              const container = this.$refs.timelinebg;
              container.scrollTo({
                left: container.scrollWidth, // 滚动到最右侧
                behavior: 'smooth' // 平滑滚动
              });
            })
            if(this.strSceneId && this.pageToken) {
              // 查询当前场次预约状态
              this.fnGetScencsStatus()
            } else {
              this.bAppointment = false
            }
            this.arrLiveData = this.currentPeriod.lives; // 直播数据
            this.selectLive = this.arrLiveData[0]; // 选中的直播
            this.kclist = this.currentPeriod.curriculum; // 课程数据

            if(this.objUserInfo) {
              this.uploadRegistrEvent(this.objUserInfo.telephone);
            }
          } else {
            this.strBannerUrl = 'https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/banner/01-banner.jpg'
            this.strFontColor = 'rgba(10, 103, 234, 1)'
            this.arrPeriods = []
            this.currentPeriod = {}
            this.arrScencsList = []
            this.strSceneId = ''
            this.arrLiveData = []
            this.selectLive = {}
            this.kclist = {}
          }
        })
        .catch((err) => {
          console.log('error==', err)
          this.$toast.center('网络开小差了，请稍后再试~~~');
        });
    },
    checkPc() {
      this.showPcTip = true;
    },
    //   浏览器类型
    judgeBrowserType() {
      if (window.navigator.userAgent.indexOf('Firefox') > -1) {
      } else {
        if (window.navigator.userAgent.indexOf('AppleWebKit') != -1) {
        } else {
          this.isShowWebkit = true;
          this.isWebkit = false;
        }
      }
    },
    // 是否从忘记密码页进入，再次展示登录弹窗
    fnIsShowLoginDialog() {
      const pageToken = Cookies.get("token") || "";
      if (this.$route.query.login) {
        if (!pageToken) {
          // 打开登录弹窗
          this.$refs.loginDialog && this.$refs.loginDialog.open();
        }
        // 去除参数
        const { login, ...params } = this.$route.query;
        this.$router.replace({
          path: this.$route.path,
          query: params,
        });
      }
    },
    //屏幕宽高
    fnGetScreenSize() {
      this.screenArry = [screen.width, screen.height];
    },
    kcSubjectClick(e) {
      this.kcSubjectIndex = e;
    },
    tabclick(e) {
      if(this.kcindex === e) return
      this.kcindex = e;
      this.kcSubjectIndex = 0;
    },

    // 获取项目
    fnGetProjectList() {
      api.getProjectList().then(res=>{
        if(res && res.data){
          res.data.forEach(item => {
            if(item.NickName.indexOf('会计') != -1) {
              this.arrProjectList[0].children.push(item)
            } else {
              this.arrProjectList[1].children.push(item)
            }
          })
        }
      })
    },

    // 选中项目
    fnSelectProject(item) {
      localStorage.setItem('selectProject', JSON.stringify(item))
      this.bShowProject = false
      this.initData()
    },

    // 切换项目
    fnProjectTabs() {
      this.bShowProject = true
      let project = JSON.parse(localStorage.getItem('selectProject'))
      this.activeProjectIndex = project.ProjectId
    },

    // 关闭选择项目弹窗
    fnCloseProjectDialog() {
      if(localStorage.getItem('selectProject')) {
        this.bShowProject = false
        return
      }
      // 第一次进入，没有选择项目
      const defaltProject = {
        "ProjectId": 1,
        "ProjectName": "高级会计师",
        "NickName": "高级会计师"
      }
      localStorage.setItem('selectProject', JSON.stringify(defaltProject))
      this.initData()
      this.bShowProject = false
    },

    // 选中期
    fnSelectStage(item, index) {
      if(this.activeStageIndex == index) return
      this.activeStageIndex = index
      this.activeSubjectIndex = 0
      this.activeLiveIndex = 0
      this.kcindex = 0
      this.kcSubjectIndex = 0

      this.currentPeriod = item; // 当前期
      this.arrScencsList = this.currentPeriod.exams || []; // 场次数据
      this.strSceneId = this.currentPeriod.exams[0].sceneId || ''; // SceneId
      if(this.strSceneId && this.pageToken) {
        // 查询当前场次预约状态
        this.fnGetScencsStatus()
      } else {
        this.bAppointment = false
      }
      this.arrLiveData = this.currentPeriod.lives || []; // 直播数据
      this.selectLive = this.arrLiveData[0] || []; // 选中的直播
      this.kclist = this.currentPeriod.curriculum || {}; // 课程数据
    },


    // 选中科目
    fnSelectSubject(item, index) {
      this.activeSubjectIndex = index
      this.strSceneId = item.sceneId
      if(this.strSceneId && this.pageToken) {
        // 查询当前场次预约状态
        this.fnGetScencsStatus()
      } else {
        this.bAppointment = false
      }
    },

    // 选中直播
    fnSelectLive(item, index) {
      this.bShowLiveimg = false
      setTimeout(() => {
        this.bShowLiveimg = true
      }, 1);
      this.activeLiveIndex = index;
      this.selectLive = item
    },

    // 查询用户是否交卷 如果交卷不展示立即预约按钮
    fnGetScencsStatus() {
      api
        .getAppointmentStatus(this.strSceneId)
        .then((res) => {
          this.bAppointment = res.data
        })
        .catch((err) => {
          this.$toast.center('网络开小差了，请稍后再试~~~');
        });
    },

    // 立即预约
    fnAppointment(item) {
      if (!this.pageToken) {
        this.fnShowLogin()
        return;
      }

      let nowDate = Date.parse(new Date($.ajax({async: false}).getResponseHeader("Date")));
      let endDate = Date.parse(item.endDate.replace(/-/g, '/'));
      if (nowDate > endDate) {
        this.$toast.center('考试已结束');
        return;
      }
      this.strSceneId = item.sceneId;
      if (this.bAppointment) {
        this.$toast.center('您已预约成功');
        return;
      }
      api
        .modeltestAppointment(item.sceneId)
        .then((res) => {
          if (res) {
            if (res.data == true) {
              if(this.strSceneId) {
                //预约成功 再次查询当前场次预约状态
                this.fnGetScencsStatus()
              }
              this.$toast.center('预约成功');
            } else {
              this.$toast.center(res.data.Message);
            }
          } else {
            this.$toast.center('网络开小差了，请稍后再试~~~');
          }
        })
        .catch((err) => {
          this.$toast.center('网络开小差了，请稍后再试~~~');
        });
    },

    // 进入考场
    enterExam(item, index) {
      if (!this.pageToken) {
        this.fnShowLogin();
        return;
      }

       // 判断是否是微信浏览器
      // var ua = window.navigator.userAgent.toLowerCase();
      // if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      //   this.isWeChat = true
      //   return
      // }

      let nowDate = Date.parse(new Date($.ajax({async: false}).getResponseHeader("Date")));
      let endDate = Date.parse(item.endDate.replace(/-/g, '/'));
      let startDate = Date.parse(item.startDate.replace(/-/g, '/'));
      // let startDate = Date.parse('2022/04/09 00:00:00');  // 四月九号之后学员就可以在考场规则页面等待进入考场了
      if (nowDate < startDate) {
        this.$toast.center('考试未开始，请耐心等待！');
        return;
      }
      if (nowDate > endDate) {
        this.$toast.center('考试已结束！');
        return;
      }

      // 判断是否交卷
      this.selectScencsItem = item
      api
        .getStudentExamStatus(this.selectScencsItem.paperId)
        .then((res) => {
          if(res) {
            if(res.data === 0 || res.data === 1) {
              // 没有作答记录 || 作答中
              this.bShowExamTip = true
            } else if(res.data === 2) {
              this.$toast.center('您已交卷！');
            } else {
              this.$toast.center('网络开小差了，请稍后再试~~~');
            }
          }
        })
        .catch((err) => {
          this.$toast.center('网络开小差了，请稍后再试~~~');
        });
    },
    fnGoExam() {
      /**
       * 1 高级会计师
       * 6 中级会计师
       * 7 初级会计师
       * 15 注册会计师
       * 38 高级经济师
       * 53 中级经济师
       */
      let that = this;
      let project_id = JSON.parse(localStorage.getItem('selectProject')).ProjectId
      // 未交卷 跳转考场规则页面
      var _t = encodeURI(encodeURI(this.objUserInfo ? this.objUserInfo.userName : ''));
      if(project_id == 1) {
        // 会计类
        window.location =
          './rules/gjkjs/signin.html?user_id=' +
          that.userid +
          '&SceneID=' +
          that.selectScencsItem.sceneId +
          '&paperId=' +
          that.selectScencsItem.paperId +
          '&user_name=' +
          _t +
          '&trueUserName=' +
          _t;
      } else if(project_id == 38) {
        // 经济类
        var _n = encodeURI(encodeURI(that.selectScencsItem.subjectName))
        window.location =
          './rules/gjjjs/Html/LoginInfo.html?userId=' +
          that.userid +
          '&sceneID=' +
          that.selectScencsItem.sceneId +
          '&papersId=' +
          that.selectScencsItem.paperId +
          '&user_name=' +
          _t +
          '&culumName=' +
          _n;
      } else {
        // 除了高经 高会，剩余项目直接跳转作答页面
        that.fnGetTikuToken(); // 获取题库token
      }
    },

    // 获取题库token
    fnGetTikuToken() {
      if(this.pageToken) {
        this.fnIsContinue(this.pageToken, this.selectScencsItem.paperId);
      } else {
        this.$toast.center('开小差了，请稍后再试~~~');
      }
    },

    // 判断是否继续做题
    fnIsContinue(access_token, papersId) {
      api
        .getStudentUncommittedExamId(papersId)
        .then((res) => {
          if(res && res.data && res.data.data) {
             //继续做题
            console.log(res.data.data)
            this.IsContinue = 1;
            this.examId = res.data.data.examId;
            let project_id = JSON.parse(localStorage.getItem('selectProject')).ProjectId
            if(project_id == 6 || project_id == 7 || project_id == 15) {
              // 中会、初会、注会
              location.href = exam_url_kj + '/#/examNow?' + 'papersId=' + this.selectScencsItem.paperId + '&userid=' + this.tiKuUserId + '&examId=' + this.examId + "&time=" + Math.random() + '&testExamDate=freegk2023';//跳转
            } else if (project_id == 53) {
              // 中级经济师
              location.href = exam_url_jj + '/zj/#/examNow?user_name=XXX' + '&papersId=' + this.selectScencsItem.paperId + '&userid=' + this.tiKuUserId + '&isContinue=' + this.IsContinue + '&sceneId=' + this.selectScencsItem.sceneId + '&examId=' + this.examId + "&time=" + Math.random() + '&isFromYuyue=Y' + "&culumName=" + encodeURI(encodeURI(this.selectScencsItem.subjectName)) + '&testExamDate=freegj';//跳转
            } else {
              location.href = exam_url_jj + '/#/examNow?user_name=XXX' + '&papersId=' + this.selectScencsItem.paperId + '&userid=' + this.tiKuUserId + '&isContinue=' + this.IsContinue + '&sceneId=' + this.selectScencsItem.sceneId + '&examId=' + this.examId + "&time=" + Math.random() + '&isFromYuyue=Y' + "&culumName=" + encodeURI(encodeURI(this.selectScencsItem.subjectName)) + '&testExamDate=freegj';//跳转
            }
            return
          }
           //未参加过考试
          this.IsContinue = 0;
          this.GetExamId(papersId, this.tiKuUserId, access_token);
        })
        .catch((err) => {
          this.$toast.center('网络开小差了，请稍后再试~~~');
        });
    },

    //获取考试记录Id
    GetExamId(papersId, userId, access_token) {
        var that = this;
        that.examId = "";//考试记录Id
        api.getExamId(papersId, userId, access_token).then((res) => {
          if(res && res.data && res.data.code == 200) {
            that.examId = res.data.data;
            let project_id = JSON.parse(localStorage.getItem('selectProject')).ProjectId
            if(project_id == 6 || project_id == 7 || project_id == 15) {
              location.href = exam_url_kj + '/#/examNow?' + 'papersId=' + that.selectScencsItem.paperId + '&userid=' + that.tiKuUserId + '&examId=' + that.examId + "&time=" + Math.random() + '&testExamDate=freegk2023';//跳转
            } else {
              location.href = exam_url_jj + '/#/examNow?access_token=' + access_token + '&user_name=XXX' + '&papersId=' + that.selectScencsItem.paperId + '&userid=' + that.tiKuUserId + '&isContinue=' + that.IsContinue + '&sceneId=' + that.selectScencsItem.sceneId + '&examId=' + that.examId + "&time=" + Math.random() + '&isFromYuyue=Y' + "&culumName=" + encodeURI(encodeURI(that.selectScencsItem.subjectName));//跳转
            }
          } else {
            that.$toast.center('网络开小差了，请稍后再试~~~');
          }
        }).catch(err => {
          that.$toast.center('网络开小差了，请稍后再试~~~');
        });
    },

    // 答案解析
    checkAnswer(item) {
      if (!this.pageToken) {
        this.fnShowLogin();
        return;
      }
      api
        .getStudentExamId(item.paperId)
        .then((res) => {
          if(res) {
            var ExamId = res.data || '';
            window.location =
              '/questionbank/analysis/index.html?PapersId=' +
              item.paperId +
              '&ExamId=' +
              ExamId +
              '&time=' +
              Math.random();
          } else {
            this.$toast.center('网络开小差了，请稍后再试~~~');
          }
        })
        .catch((err) => {
          this.$toast.center('网络开小差了，请稍后再试~~~');
        });
    },

    // 观看直播
    fnLiveClick() {
      if (!this.pageToken) {
        this.fnShowLogin();
        return;
      }
      window.location.href = this.selectLive.link;
    },

    // 登录bengin
    fnShowLogin() {
      this.$refs.loginDialog && this.$refs.loginDialog.open();
    },
    // 登录弹窗 - 成功
    onLoginSuccess(data) {
      if (!data || !data.access_token) {
        return;
      }
      this.pageToken = data.access_token;
      // 登录成功 获取用户信息
      this.getUserDetail(data.access_token);
    },
    // 登录弹窗 - 取消登录
    onLoginCancel() {},
    // 获取用户登录信息
    async getUserDetail(token) {
      const checkProjectSelection = () => {
        // 是否需要弹窗选择项目
        if(!localStorage.getItem('selectProject')) {
          this.bShowProject = true
        } else {
          this.initData()
        }
      };
      try {
        const res = await api.getUserInfo(token);
        const resQuestionBank = await api.getQuestionBankUserInfo(token);
        if (res && res.data) {
          let user = {
            userName: res.data.userName,
            headImg: res.data.avatar,
            headImgUrl: res.data.avatar,
            telephone: res.data.phone,
            encryptedTelephone: res.data.encryptedPhone,
          };
          this.objUserInfo = user;
          this.userid = resQuestionBank && resQuestionBank.data && resQuestionBank.data.userId || '';
          this.tiKuUserId = resQuestionBank && resQuestionBank.data && resQuestionBank.data.masterId || '';
          // 登录成功 上报方案
          this.uploadRegistrEvent(res.data.phone);
          // 存用户信息
          Cookies.set("token", token, {
            expires: 365,
            path: " / ",
            domain: api.COOKIE_DOMAIN,
          });
          Cookies.set("access_token", token, {
            expires: 365,
            path: " / ",
            domain: api.COOKIE_DOMAIN,
          });
          Cookies.set(
            "loginUser",
            encodeURIComponent(JSON.stringify(user)),
            { expires: 365, path: " / ", domain: api.COOKIE_DOMAIN }
          );
          var str = encodeURIComponent(
            '{"Status":"succ","Data":{"id":""' +
              ',"encryptedTelephone":"' +
              user.encryptedTelephone +
              '","user_name":"' +
              user.userName +
              '","head_img":"' +
              user.headImgUrl +
              '","access_token":"' +
              (token || "") +
              '"},"ErrorInfo":null,"Message":null}'
          );
          Cookies.set("lJcomcn_UserInfo", str, {
            expires: 365,
            path: " / ",
            domain: api.COOKIE_DOMAIN,
          });
        } else {
          this.pageToken = '';
          this.userid = ''
          this.tiKuUserId = ''
          this.objUserInfo = null;
          this.pageToken = "";
          this.fnClearCookie();
        }
        checkProjectSelection();
      } catch (err) {
        this.pageToken = '';
        this.userid = ''
        this.tiKuUserId = ''
        this.objUserInfo = null;
        this.pageToken = "";
        this.fnClearCookie();
        checkProjectSelection();
      }
    },
    // 账号密码登录后 上报推广方案
    async uploadRegistrEvent(phone) {
      try {
        let project_id = JSON.parse(localStorage.getItem('selectProject')).ProjectId
        let params = {
          registrationId: this.RegNID, // 方案id
          phone: phone,
          projectId: project_id,
          ChannelSource: this.ChannelSource,
          node: '学员参与了官网自由模考',
        };
        const res = await api.uploadRegistrEvent(params);
        console.log("上报crm", res);
      } catch (err) {
        console.log("上报crm失败", err);
      }
    },
    // 退出登录
    fnLogout() {
      this.fnClearCookie();
      this.pageToken = '';
      this.objUserInfo = null;
      this.userid = '';
      this.tiKuUserId = '';
      this.initData()
    },
    // 清除cookie
    fnClearCookie() {
      Cookies.set("token", "", {
        expires: 365,
        path: " / ",
        domain: api.COOKIE_DOMAIN,
      });
      Cookies.set("access_token", "", {
        expires: 365,
        path: " / ",
        domain: api.COOKIE_DOMAIN,
      });
      Cookies.set("loginUser", "", {
        expires: 365,
        path: " / ",
        domain: api.COOKIE_DOMAIN,
      });
      Cookies.set("lJcomcn_UserInfo", "", {
        expires: 365,
        path: " / ",
        domain: api.COOKIE_DOMAIN,
      });
    },
    // 登录end

    // 获取路由参数
    getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    // 判断浏览器类型
    checkOs() {
      var ua = navigator.userAgent,
          isWindowsPhone = /(?:Windows Phone)/.test(ua),
          isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
          isAndroid = /(?:Android)/.test(ua),
          isFireFox = /(?:Firefox)/.test(ua),
          isChrome = /(?:Chrome|CriOS)/.test(ua),
          isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
          isPhone = /(?:iPhone)/.test(ua) && !isTablet,
          isPc = !isPhone && !isAndroid && !isSymbian;
      return {
          isTablet: isTablet,
          isPhone: isPhone,
          isAndroid: isAndroid,
          isPc: isPc
      };
    },
    // copy内容
    copyText() {
      var text = document.getElementById("text").innerText;
      var input = document.getElementById("input");
      input.value = text; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$toast.center("复制成功,快去浏览器打开吧")
    }
  },
};
</script>
<style lang="scss">
.index {
  .top {
    margin: 0 auto;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 65px;
    background: #fff;
    .logo-con {
      display: flex;
      align-items: center;

      .logo {
        width: 140px;
        height: 36.22px;
        margin-right: 12px;
      }

      .logo-text {
        width: 150px;
      }
    }

    .topfont {
      display: flex;
      font-size: 18px;

      .top-nav {
        width: 495px;
        display: flex;
        align-items: center;

        .nav-item {
          display: inline-block;
          padding: 4px 10px;
          color: #333;
          margin: 0 20px;
          border-radius: 4px;
          font-size: 18px;
          cursor: pointer;
          &:hover {
            font-weight: 600;
          }
        }
      }

      .login-btn {
        width: 116px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 20px;
        font-size: 16px;
        background: rgba(224, 44, 22, 0.8);
        color: #fff;
        cursor: pointer;
      }
    }
  }
  .w1200 {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  .changeProject {
    position: fixed;
    left: 40px;
    top: 40%;
    z-index: 100;
    cursor: pointer;
    .changeProject-img {
      width: 120px;
    }
    .cursor-img {
      width: 39px;
      position: absolute;
      left: 55px;
      top: 95px;
    }
  }
  .banner {
    min-width: 1200px;
    height: 400px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: auto 100%;
    .bannerCon {
      position: relative;
      width: 1200px;
      height: 400px;
      margin: 0 auto;
      .banner-text {
        position: absolute;
        left: 0;
        top: 55%;
        width: 238px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 18px;
        background: rgba(0, 0, 0, 0.2);
        font-size: 18px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        img {
          margin-right: 10px;
          width: 32px;
          height: 42.91px;
        }
      }
      .banner-ewm {
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -122px;
        width: 285px;
        height: 164px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url('https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/gzh-bg.png') no-repeat center center;
        background-size: 100% 100%;
        img {
          width: 104px;
          margin: 10px 10px 0 0;
        }
        .banner-ewm-text {
          color: #fff;
          text-align: center;
          line-height: 20px;
          font-size: 15px;
          font-weight: 600;
        }
      }
    }
  }
  .projects-wrap {
    position: relative;
    .projects {
      display: flex;
      flex-direction: column;
      position: absolute;
      left: 10%;
      li {
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: rgba(245, 245, 245, 1);
        color: rgba(128, 128, 128, 1);
        font-size: 16px;
        cursor: pointer;
      }
      .active {
        color: #fff;
        font-weight: 800;
      }
    }
  }

  .timelinebgWrap {
    box-sizing: border-box;
    padding: 0 20px;
    width: 1200px;
    height: 180px;
    margin: 0 auto;
    margin-top: -90px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    border-radius: 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px  rgba(0, 0, 0, 0.1);
    .calendar-img {
      width: 104px;
      margin-right: 30px;
    }
    .timelinebg {
      width: 1000px;
      height: 140px;
      padding-top: 14px;
      display: flex;
      flex-shrink: 0;
      overflow-x: auto;
      .timeline2 {
        width: 250px;
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        .status {
          position: absolute;
          right: 7px;
          top: -10px;
          width: 87px;
          height: 38px;
          text-align: center;
          line-height: 30px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          background-size: 100% 100%;
        }
        .status-end {
          background: url('https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/ended.png') no-repeat center center;
        }
        .status-pending {
          background: url('https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/pending.png') no-repeat center center;
        }
        .status-nostart {
          background: url('https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/no-start.png') no-repeat center center;
        }
        .name{
          font-size: 20px;
          font-weight: 500;
          color: rgba(166, 166, 166, 1);
        }
        .time {
          width: 196px;
          height: 33px;
          text-align: center;
          line-height: 33px;
          background: rgba(0, 0, 0, 0.05);
          color: rgba(166, 166, 166, 1);
          font-size: 12px;
          font-weight: 500;
          border-radius: 18px;
        }
        .time-active {
          background: rgba(64, 131, 246, 1);
          color: #fff;
        }
        .linebg {
          margin: 22px 0 22px 0;
          position: relative;
          width: 250px;
          height: 14px;
          // background: rgba(64, 131, 246, 1);
          background: #f4f4f4;
          .cir {
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -12px;
            margin-top: -15px;
            border: 6px solid #a6a6a6;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #fff;
          }
          .cir-active {
            border: 6px solid rgba(64, 131, 246, 1);
          }
        }
      }
      .borderRadius:first-child {
        .linebg {
          border-radius: 7px 0 0 7px;
        }
      }
      .timeline1 {
        .name{
          color: #000;
        }
      }
      .timeline3 {
        left: -7px;
        z-index: 0;
        cursor: default;
        .name{
          color: #ff9a17;
        }
        .time {
          background: rgba(0, 0, 0, 0.05);
          color: #a6a6a6;
        }
        .linebg {
          width: 250px;
          height: 14px;
          border-radius: 7px;
          background: #f4f4f4;
          .cir {
            border: 6px solid #ff9a17;
          }
        }
      }
    }
  }

  .maintitle {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    margin-top: 30px;
    margin-bottom: 20px;
    font-size: 32px;
    font-weight: 600;
    color: #000;

    img {
      width: 95px;
      height: 27px;
      margin-left: 20px;
      margin-right: 20px;
      margin-top: 6px;
    }
  }
  .ksap {
    width: 1200px;
    margin: 30px auto;
    height: 436px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 20px 20px 20px 20px;
    display: flex;
    .subjects {
      width: 180px;
      padding: 30px 0 40px 20px;
      ul {
        display: flex;
        flex-direction: column;
        li {
          margin-bottom: 10px;
          font-size: 18px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          height: 55px;
          line-height: 55px;
          cursor: pointer;
        }
        .active {
          border-radius: 30px 0 0 30px;
          font-weight: 800;
          background: #fff;
        }
      }
    }
    .scenInfo {
      width: 1020px;
      padding: 20px;
      background: url(https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/m/mokaobg.png) no-repeat center center;
      background-size: 100% 100%;
      border-radius: 0 18px 18px 0;
    }
    .ksaptop {
      display: flex;
      align-items: center;
      .ksaptip {
        font-size: 20px;
        flex: 1;
        background: url(../assets/icon.png) left center no-repeat;
        padding-left: 40px;
        line-height: 40px;
      }
      .ksaptip2 {
        color: #0c29b0;
        border-bottom: 2px solid #0c29b0;
        cursor: pointer;
        font-size: 20px;
        margin-right: 20px;
        line-height: 35px;
        height: 35px;
      }
    }
    .pad30 {
      padding: 30px;
    }
    .ksapbg {
      height: 250px;
      box-sizing: border-box;
      position: relative;
      .mktitle {
        margin-top: 20px;
        margin-bottom: 10px;
        height: 40px;
        line-height: 40px;
        .mktitlefont {
          font-size: 24px;
          font-weight: bold;
          float: left;
        }
        .mktitledesc {
          font-size: 18px;
          float: right;
        }
      }
      .mkicon {
        ul {
          font-size: 16px;
          overflow: hidden;
        }
        li {
          background: url(../assets/ok.png) no-repeat left center;
          padding-left: 28px;
          height: 30px;
          line-height: 30px;
          float: left;
          margin-right: 25px;
        }
      }
      .mkdesc {
        color: #666;
        font-size: 18px;
        line-height: 36px;
        margin-top: 165px;
        display: flex;
        flex-direction: column;
        span {
          display: flex;
          align-items: center;
        }
        img {
          width: 20px;
          margin-right: 4px;
        }
      }
      .mkstatus {
        position: absolute;
        bottom: 20px;
        left: 520px;
        width: 100px;
      }
      .enterbtn {
        position: absolute;
        bottom: 20px;
        right: 90px;
        text-align: center;
        font-size: 20px;
        color: #ffffff;
        width: 150px;
        height: 50px;
        line-height: 50px;
        background: linear-gradient(143.58deg, rgba(91, 199, 255, 1) 0%, rgba(46, 149, 250, 1) 100%);
        border-radius: 25px;
      }
      .lookbtn {
        position: absolute;
        bottom: -49px;
        right: 90px;
        text-align: center;
        font-size: 20px;
        color: #ffffff;
        width: 150px;
        height: 50px;
        line-height: 50px;
        border-radius: 25px;
        background: linear-gradient(142.12deg, rgba(253, 153, 29, 1) 0%, rgba(235, 103, 95, 1) 100%);
      }
    }
    .ksapbot {
      padding: 20px;
    }
  }

  .exam-remark {
    position: relative;
    width: 900px;
    height: 150px;
    margin: 0 auto;

    margin-top: -10px;
    border-radius: 20px;
    background: linear-gradient(139.6deg, rgba(253, 153, 29, 1) 0%, rgba(235, 103, 95, 1) 100%);
    color: rgba(255, 255, 255, 1);
    .exam-remark-title {
      padding-top: 30px;
      margin: 0 0 10px 38px;
      font-size: 18px;
      font-weight: 600;
      line-height: 30px;
    }
    .remark-item {
      margin-left: 44px;
      font-size: 16px;
      line-height: 30px;
      span {
        text-decoration:underline;
        cursor: pointer;
      }
    }
    img {
      width: 20px;
      position: absolute;
    }
    .remark-img1 {
      left: 64px;
      top: -46px;
    }
    .remark-img2 {
      right: 64px;
      top: -46px;
    }
  }
  .f18 {
    font-size: 18px;
  }
  .f24 {
    font-size: 24px;
  }
  a.blue {
    color: #0c29b0;
    text-decoration: underline;
  }
  .lin30 {
    line-height: 30px;
  }
  .livebg {
    box-sizing: border-box;
    margin-top: 40px;
    padding: 20px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 20px 20px 100px 20px;
    .liveplay {
      display: flex;
      width: 700px;
      height: 420px;
      text-align: center;
      position: relative;
      .liveimg {
        width: 700px;
        height: 420px;
        animation: movedh 2s;
        img {
          width: 700px;
          height: 420px;
        }
        .liveImgBg {
          width: 700px;
          height: 420px;
          position: absolute;
          left: 0px;
          top: 0px;
          background: rgba(0, 0, 0, 0.4);
        }
        .liveStatus {
          position: absolute;
          left: 0;
          top: 0;
          padding: 8px 15px;
          line-height: 1;
          color: #fff;
          font-size: 18px;
          border-bottom-right-radius: 14px;
          background: rgba(141, 137, 136, 0.6);
        }
        .liveBtn {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          display: block;
          width: 146px;
          height: 42px;
          line-height: 42px;
          border-radius: 50px;
          font-size: 18px;
          font-weight: bold;
          text-decoration: none;
          color: #fff;
          background: #ff7200;
          background-image: -webkit-linear-gradient(top, #ffb412, #ff7200);
          cursor: pointer;
        }
      }
      .livemain {
        box-sizing: border-box;
        padding: 0 10px;
        text-align: left;
        .lineTitle {
          font-size: 24px;
          font-weight: 700;
          color: rgba(56, 56, 56, 1);
        }
        ul {
          width: 440px;
          height: 360px;
          overflow-y: auto;
          margin-top: 15px;
          padding-left: 20px;
          li {
            padding: 18px 0 18px 25px;
            color: rgba(56, 56, 56, 1);
            position: relative;
            z-index: 1;
            display: flex;
            flex-direction: column;
            border-left: 2px solid rgba(204, 204, 204, 1);
            cursor: pointer;
            .time {
              font-size: 20px;
              margin: 10px 0 16px 0;
            }
            .title {
              font-size: 18px;
            }
            .teacher {
              margin-top: 8px;
              font-size: 14px;
            }
            img {
              width: 21px;
              position: absolute;
              left: -12px;
              top: 40px;
              z-index: 100;
            }
          }
        }
      }
    }
  }

  .tabs {
    padding-left: 7px;
    margin-top: 30px;
  }
  .tabs span.active {
    font-weight: 600;
    background: linear-gradient(180deg, rgba(255, 191, 99, 1) 0%, rgba(255, 159, 23, 1) 100%);
  }
  .tabs span {
    margin-left: 13px;
    display: inline-block;
    width: 151px;
    height: 60px;
    border-radius: 20px 20px 0px 0px;
    background: linear-gradient(90deg, rgba(176, 25, 40, 1) 0%, rgba(255, 84, 82, 1) 100%);
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
  }
  .bluebg {
    border-radius: 20px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    padding: 20px;
    padding-bottom: 15px;
    .kcSubject {
      display: flex;
      p {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        margin-bottom: 20px;
        margin-right: 16px;
        width: 145px;
        height: 40px;
        border-radius: 7px;
        background: rgba(255, 243, 240, 1);
        font-size: 16px;
        font-weight: 400;
        color: rgba(56, 56, 56, 1);
        text-align: center;
        line-height: 40px;
        border: 1px solid rgba(255, 230, 216, 1);
        cursor: pointer;
      }
      .active {
        font-weight: 600;
        background: linear-gradient(90deg, rgba(255, 191, 99, 1) 0%, rgba(255, 159, 23, 1) 100%);
        color: #fff;
      }
    }
    .kcmain {
      position: relative;
      display: flex;
      margin-bottom: 25px;
      padding-top: 24px;
      background: rgba(255, 242, 238, 1);
      border-radius: 16px;
      height: 360px;
      box-sizing: border-box;
    }
    .kcname {
      width: 80px;
      height: 300px;
      background: rgba(255, 190, 139, 1);
      border-radius: 0px 19.33px 19.33px 0px;
      font-size: 24px;
      color: rgba(68, 31, 5, 1);
      font-weight: bold;
      padding: 25px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      position: absolute;
      left: 0px;
      top: 31px;
    }
    .kcbuy {
      margin-top: 34px;
      background: url(https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/kcbg.png) no-repeat;
      width: 266px;
      height: 315px;
      margin-left: 122px;
      position: relative;
    }
    .price {
      position: relative;
      color: rgba(244, 96, 88, 1);
      font-size: 22px;
      padding-top: 32px;
      text-align: center;

      strong {
        font-size: 35px;
      }
    }
    .buybtn {
      width: 212.67px;
      height: 48.33px;
      line-height: 49px;
      background: linear-gradient(180deg, rgba(240, 85, 77, 1) 0%, rgba(253, 120, 112, 1) 100%);
      color: rgba(255, 255, 255, 1);
      border-radius: 96.67px;
      text-align: center;
      font-size: 19.33px;
      display: block;
      position: absolute;
      left: 27px;
      top: 97px;
      transition: .4s;
    }
    .buybtn:hover {
      transform: translateY(-3px);
    }

    .kcright {
      display: flex;
      margin: 0 30px;
    }

    .kcdiv1,
    .kcdiv2,
    .kcdiv3 {
      width: 220px;
      border: 1px solid #ebebeb;
      height: 310px;
    }

    .kcdiv1 {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    .kcdiv3 {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .kcdiv2 {
      border-left: 0px;
      border-right: 0px;
    }

    .kctitle {
      border-bottom: 1px solid #ebebeb;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      height: 50px;
      line-height: 50px;
    }

    .kcright ul {
      padding: 20px;
      padding-right: 0px;
    }

    .kcright li {
      background: url('https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/kcicon.jpg') left center no-repeat;
      background-size: 15px 15px;
      padding-left: 23px;
      font-size: 16px;
      height: 30px;
      line-height: 30px;
    }
  }
  .flex-between {
    justify-content: space-between;
  }
  .flex {
    display: flex;
  }
  .com-wth {
    width: 1200px;
    margin: 0 auto;
  }
  //弹窗
  .mask {
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalcen {
      width: 550px;
      position: relative;
      padding: 30px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 20px;
      .close-img  {
        position: absolute;
        right: 18px;
        top: 16px;
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
      .modalicon {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background: #fff;
        position: absolute;
        left: 50%;
        margin-left: -40px;
        top: -40px;
        text-align: center;
        box-sizing: border-box;
        padding-top: 15px;
        img {
          width: 40px;
        }
      }
      .modaltitle {
        text-align: center;
        font-size: 26px;
        padding-top: 20px;
        color: #223eb5;
        font-weight: bold;
      }
      .modalfont {
        font-size: 20px;
        line-height: 34px;
        margin-top: 20px;
      }
      .modalbtngroup {
        cursor: pointer;
        margin-top: 30px;
        margin-left: auto;
        margin-right: auto;
        width: 150px;
        height: 50px;
        border: 1px solid #142caa;
        border-radius: 25px;
        text-align: center;
        color: #ffffff;
        line-height: 50px;
        background: linear-gradient(117deg, #142caa, #3557c4);
        font-size: 22px;
      }
      .modalbtngroup2 {
        padding: 0 0.35rem;
        overflow: hidden;
        margin-top: 0.5333rem;
        .modalbtn1 {
          width: 2.1rem;
          float: left;
          height: 0.7rem;
          border: 0.0133rem solid #142caa;
          border-radius: 0.4667rem;
          text-align: center;
          color: #142caa;
          line-height: 0.7rem;
          font-size: 0.36rem;
          cursor: pointer;
        }
        .modalbtn2 {
          width: 2.1rem;
          float: right;
          height: 0.7rem;
          border: 0.0133rem solid #142caa;
          border-radius: 0.4667rem;
          text-align: center;
          color: #142caa;
          line-height: 0.7rem;
          font-size: 0.36rem;
          cursor: pointer;
        }
      }
      .fexdiv {
        display: flex;
        align-items: flex-start;
        img {
          margin-right: 10px;
        }
      }
      .modaltip {
        color: #666;
        font-size: 16px;
      }
      .btnWrap {
        display: flex;
        justify-content: space-between;
        .modalbtngroup {
          width: 180px;
        }
      }
    }
  }

  .wxTips {
    margin-bottom: 56px;
    font-size: 18px;
    font-weight: 800;
    .linkInfo {
      margin-top: 20px;
      span:nth-child(1) {
        color: #2f50c0;
      }
      span:nth-child(2) {
        margin-left: 16px;
        padding: 5px 10px;
        color: #2f50c0;
        border: 1px solid #2f50c0;
        border-radius: 6px;
        cursor: pointer;
      }
    }
  }
}
.project-wrap {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  .nav-item {
    font-size: 20px;
    font-weight: 600;
    img {
      float: left;
      width: 30px;
      margin-top: 3px;
      margin-right: 8px;
    }
    span {
      float: left;
    }
  }
}
.session-projects {
  clear: both;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .project-item {
    width: 125px;
    height: 38px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 12px 20px 20px 0;
    line-height: 39px;
    border: 1px solid #E6E6E6;
    border-radius: 20px;
    font-size: 16px;
    text-align: center;
    color: #666;
    font-weight: 400;
    cursor: pointer;
    &:hover, &.is-active {
      color: #fff;
      background: linear-gradient(0deg, #DC2122 0%, #FF724C 100%);
    }
  }
  .active {
    color: #fff;
    background: linear-gradient(0deg, #DC2122 0%, #FF724C 100%);
  }
  .project-item:nth-child(4n) {
    margin-right: 0;
  }
}
@keyframes movedh {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

// 滚动条样式 begin
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #F5F5F5;
}

/*滚动条轨道*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  background-color: #F5F5F5;
}

/*滚动条小方块*/
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #999;
}

// 滚动条样式 end

/* 登录bengin */
.lx-toast {
  z-index: 10000000 !important;
  max-width: 92% !important;
}

input:focus {
  outline: none;
}


.loading {
  color: #fff;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  img {
    width: 40px;
    margin-bottom: 10px;
    animation: rotate 2s linear infinite;
  }
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.logout {
  font-style: normal;
  cursor: pointer;
}

.transition4 {
  transition: .4s;
}
.transition4:hover {
  transform: translateY(-3px);
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue